<div class="uk-child-width-1-1@s" uk-grid>
  <div>
    <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
      style="background-image: url(../../assets/contact.png)">
      <div class="uk-section uk-light">
        <div class="uk-container-small uk-width-2xlarge" style="padding-top: 20px">
          <div>
            <h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical" style="margin-bottom: 10px">
              Contact
            </h1>
          </div>
          <div>
            <p class="uk-padding-large uk-text-left uk-padding-remove-vertical" style="font-size: 20px">
              Don't wait, just dial our number. We are always here to serve you
              with all the tremendous and latest technologies for your dream
              goals. WebSoulLabs will be there with you to grow your business
              until you reach the destination.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="uk-container uk-padding" style="padding-left: 90px; padding-bottom: 5px">
  <!--<div class=" uk-child-width-1-3@m  uk-grid-match uk-padding " uk-grid>

        <div>
            <div class="uk-card uk-card-hover  uk-card-small uk-card-body">
                <h5 class="uk-card-title">HR Enquiry :</h5>
                <span uk-icon="icon: phone" style="padding-right: 10px;"></span>123456987<br><br>
                <span uk-icon="icon:  mail" style="padding-right: 10px;"></span>hr@gmail.com<br>

            </div>
        </div>
        <div>
            <div class="uk-card uk-card-hover  uk-card-small uk-card-body">
                <h3 class="uk-card-title">Business Enquiry :</h3>
                <span uk-icon="icon: phone" style="padding-right: 10px;"></span>123456987<br><br>
                <span uk-icon="icon:  mail" style="padding-right: 10px;"></span>hr@gmail.com
            </div>
        </div>
    </div>-->
  <div class="uk-grid-divider uk-child-width-1-2@m" uk-grid>
    <div>
      <p class="uk-card-title"><b>Business Enquiry :</b></p>
      <div class="uk-child-width-1-2@s" uk-grid>
        <div>
          <span uk-icon="icon: phone" style="padding-right: 10px"></span>+91 8848430565<br /><br />
          <span uk-icon="icon:  mail" style="padding-right: 10px"></span>websoul467@gmail.com
        </div>

        <div>
          <span uk-icon="icon: whatsapp" style="padding-right: 10px"></span>+91 7356189747<br /><br />

          <span class="fa fa-skype" style="padding-right: 10px; width: 20px"></span>aneesht240
        </div>
      </div>
    </div>
    <div>
      <p class="uk-card-title"><b>HR Enquiry :</b></p>
      <span uk-icon="icon: phone" style="padding-right: 10px"></span>+91 7356189747<br /><br />
      <span uk-icon="icon:  mail" style="padding-right: 10px"></span>hrwebsoul@gmail.com<br />
    </div>
  </div>
</div>

<div class="uk-section uk-padding" style="padding-bottom: 0px; margin-left: 50px">
  <div class="uk-container-small">
    <h5 class="uk-text-left@s text-dark" style="margin-bottom: 0px">
      <b>Looking for the best be team to develop web or mobile app?</b>
    </h5>
    <p class="uk-text-left@s" style="margin-top: 5px">
      For any technical solutions please just fill up the given form. We will
      contact you within 24 hours.
    </p>
  </div>
  <div class="uk-container-small">
    <form [formGroup]="createForm" class="uk-grid-small" uk-grid>
      <div class="uk-width-1-2@s">
        <input formcontrolName="name" #name class="uk-input" type="text" placeholder="Name *" />
      </div>
      <div class="uk-width-1-2@s">
        <input formcontrolName="email" #email class="uk-input" type="text" placeholder="Email *" />
      </div>
      <div class="uk-width-expand@m uk-child-width-expand">
        <input formcontrolName="phone" #phone class="uk-input telephone" type="text" ng2TelInput
          [ng2TelInputOptions]="{ initialCountry: 'in' }" (hasError)="hasError($event)"
          (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)"
          (countryChange)="onCountryChange($event)" />
      </div>

      <div class="uk-width-1-2@s">
        <input formcontrolName="subject" #subject class="uk-input" type="text" placeholder="Subject" />
      </div>
      <div class="uk-margin uk-width-1-1">
        <textarea formcontrolName="message" #message class="uk-textarea" rows="8" placeholder="Message *"></textarea>
      </div>
      <!--<div class="uk-width-1-2@s">
                <re-captcha (resolved)="resolved($event)" siteKey="6LeYlK4ZAAAAABLAo3-WLfOhIsPzhIH-wgy9WKNl"></re-captcha>
                </div>-->
      <div class="uk-width-1-2@d-xl-inline-block">
        <p>
          <a href="#mo1" uk-toggle>
            <button type="submit" class="uk-button uk-button-primary" (click)="
                addContact(
                  name.value,
                  email.value,
                  phone.value,
                  subject.value,
                  message.value
                )
              ">
              Submit
            </button></a>

          <button class="uk-button uk-button-primary uk-display-block uk-float-right uk-align-right">
            Reset
          </button>
        </p>
      </div>
    </form>
    <div id="mo1" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>

        <div class="uk-modal-body">
          <p class="uk-text-medium uk-text-justify">
            Thanks for contacting us. We've received your message and appreciate you reaching out.
          </p>
        </div>
        <div class="uk-modal-footer uk-text-right">
          <button class="uk-button uk-button-primary uk-modal-close" type="button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div></div>
